import {IBoard, parseBoard, serializeBoard} from "./core/IBoard";

export const saveBoard = (board: IBoard) => {

    const serializedBoard = serializeBoard(board);
    window.localStorage.setItem('board.' + board.id, serializedBoard);


    //save that we have stored this board
    const boardIDs = window.localStorage.getItem('boardIDs');
    if(boardIDs == null){
        window.localStorage.setItem('boardIDs', "" + board.id)
    }
    else
    {
        const splitBoardIDs = new Set(boardIDs.split(','));
        if(!splitBoardIDs.has("" + board.id))
        {
            window.localStorage.setItem('boardIDs', boardIDs + "," + board.id)
        }
    }

}

export const getBoards = (): IBoard[] => {

    const boardIDSstring = window.localStorage.getItem('boardIDs');
    if(boardIDSstring == null) return [];

    const boardIDs = boardIDSstring.split(',');

    const boards: IBoard[] = [];

    boardIDs.forEach((boardID) => {

        const board = getBoardById(boardID);
        if(board != null) {
            boards.push(board);
        }
    });

    return boards;
}

export const getBoardById = (id: string | number): IBoard | null => {

    const boardString = window.localStorage.getItem('board.' + id);
    if(boardString != null) {
        return parseBoard(boardString);
    }
    return null;
}

export const deleteBoardById = (id: string|number) => {

    window.localStorage.removeItem('board.' + id);

    const boardIDSstring = window.localStorage.getItem('boardIDs');
    if(boardIDSstring == null) return;

    const boardIDs = boardIDSstring.split(',');

    const stringID = typeof id === 'number' ? id.toString() : id;
    const newBoardIDs = boardIDs.filter((boardId) => boardId !== stringID);

    window.localStorage.setItem('boardIDs', newBoardIDs.join(','));
}